import { kebabCase } from "@/core/utils/utils";
import identificationService from "@/core/services/identification.service";
import useAccountStore from "@/apps/shared/organization/store/accountStore";

export const addUserBodyClass = () => {
  const cirxUser = identificationService.getUser();

  if (cirxUser?.getCurrentType()) document.body.classList.add("role-" + kebabCase(cirxUser.getCurrentType()));

  const { name } = useAccountStore();
  if (name) {
    document.body.classList.add("organization-" + kebabCase(name));
  }
};

export const removeUserBodyClass = () => {
  const userClassList = [...document.body.classList].filter(
    (className) => className.startsWith("role-") || className.startsWith("organization-")
  );

  for (const className of userClassList) {
    document.body.classList.remove(className);
  }
};
